import React, { useEffect, useState } from 'react';

// components
import { FormGroup, Input, Row, Col, Nav, NavItem, NavLink, Card, CardBody, CardHeader, Button, Spinner } from "reactstrap";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

// helpers
import { formateDateandTime } from "../../../helpers/formats.js";

export default function InspecoesImpressao({ boletimVistoria }) {

    return (
        <>
            {boletimVistoria.boletimVistoriaInspecoes.map((m, key) => (
                <div className="contentGroup">
                    <h5 className="subtitleCardInfo">Inspeção: {m.local}</h5>
                    <div className="row align-items-end">
                        <div className="col-12 pb-2">
                            <strong>Endereço: </strong><span>{m.logradouro + ", " + m.bairro}</span>
                        </div>                    
                        <div className="col-6 pb-2">
                            <strong>Início: </strong><span>{formateDateandTime(m.dataHoraInicio)}</span>
                        </div>
                        <div className="col-6 pb-2">
                            <strong>Fim: </strong><span>{formateDateandTime(m.dataHoraFim)}</span>
                        </div>
                    </div>
                    <div key={key} className="row mt-4 mb-4">
                        {m.boletimVistoriaInspecaoFotos.filter(f => f.nomeArquivo.split('.').pop().toLowerCase() != "pdf")
                            .map((foto, keyfoto) => (                            
                            <div className="col-3 text-center mt-4" key={keyfoto}>
                                <img src={foto.nomeArquivo} style={{ cursor: "pointer" }} width="40%" height="auto" />
                            </div>
                        ))}
                    </div>
                    <div>
                        <div className="col-12">
                            <TableContainer component={Paper}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell align="left">Pergunta</StyledTableCell>
                                            <StyledTableCell align="left">Resposta</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {m.boletimVistoriaQuestoes.map((n, key2) => (
                                            <StyledTableRow key={key2}>
                                                <StyledTableCell align="left">{n.formularioVistoriaQuestao_Identificacao}</StyledTableCell>
                                                <StyledTableCell align="left">{n.valor}</StyledTableCell>
                                                <StyledTableCell component="th" scope="row">
                                                    {n.penalidade && <i className="fas fa-exclamation-circle text-danger"></i>}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                    <hr />
                    <div>
                        <div className="col-12">
                            <label><i className="fas fa-exclamation-circle text-danger"></i> Respondido com inconformidade</label>
                        </div>
                    </div>                    
                </div>
            ))}
        </>
    );
}

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontWeight: "bold",
        fontFamily: "Montserrat",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
    body: {
        fontFamily: "Montserrat",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);